import { render, staticRenderFns } from "./ContractualItemsSelectModal.vue?vue&type=template&id=e3854994&scoped=true"
import script from "./ContractualItemsSelectModal.vue?vue&type=script&lang=js"
export * from "./ContractualItemsSelectModal.vue?vue&type=script&lang=js"
import style0 from "./ContractualItemsSelectModal.vue?vue&type=style&index=0&id=e3854994&prod&lang=scss"
import style1 from "./ContractualItemsSelectModal.vue?vue&type=style&index=1&id=e3854994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3854994",
  null
  
)

export default component.exports